// Central data-testid constants
export const HOME = {
  finderBrand: "vehicle-finder-brand-select",
  finderModel: "vehicle-finder-model-select",
  finderSubmit: "vehicle-finder-submit-btn",
  ctaFind: "hero-cta-find-btn",
  ctaCatalog: "hero-cta-catalog-btn",
};
